import axios from "axios";

export async function getStores() {
    return axios.get(`${process.env.REACT_APP_API_URL}/stores`);
}
